import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import Spinner from './Spinner/Spinner';

const LoaderContainer = styled('div')({
  display: 'inline-flex',
});

const LoadingV2 = (): ReactElement => {
  return (
    <LoaderContainer>
      <Spinner />
    </LoaderContainer>
  );
};

export default LoadingV2;
